import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

import { AuthService } from './authService.service';

@Injectable({
  providedIn: 'root'
})
export class MsalBootstrapService {
  #ready?: Promise<void>;

  ensureReady(msalService: MsalService, authService: AuthService): Promise<void> {
    if (!this.#ready) {
      this.#ready = this.#bootstrap(msalService, authService);
    }

    return this.#ready;
  }

  reset(): void {
    this.#ready = undefined;
  }

  async #bootstrap(msalService: MsalService, authService: AuthService): Promise<void> {
    await msalService.instance.initialize();

    const redirectResult = await msalService.instance.handleRedirectPromise();

    if (redirectResult?.account) {
      msalService.instance.setActiveAccount(redirectResult.account);

      if (redirectResult.idToken) {
        authService.setAzureIdToken(redirectResult.idToken);
      }

      return;
    }

    if (!msalService.instance.getActiveAccount()) {
      const accounts = msalService.instance.getAllAccounts();

      if (accounts.length > 0) {
        msalService.instance.setActiveAccount(accounts[0]);
      }
    }
  }
}
